package ai.wagemix.web.components

import ai.wagemix.net.models.WMBadge
import ai.wagemix.web.theme.WMBodySmallTextStyle
import ai.wagemix.web.theme.WMCardTitleTextStyle
import ai.wagemix.web.theme.WMInlineGapVar
import ai.wagemix.web.theme.WMPillCornerVar
import ai.wagemix.web.theme.WMTierMedalVar
import ai.wagemix.web.theme.WMTightGapVar
import ai.wagemix.web.theme.WMWebColors
import ai.wagemix.web.theme.WMWebTheme
import androidx.compose.runtime.Composable
import com.fsryan.foundation.web.theme.fs
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette

/** The tier colour of a pay-range badge; `null` for [WMBadge.None]. */
fun WMWebColors.tierColor(badge: WMBadge): Color? = when (badge) {
    WMBadge.Bronze -> tierBronze
    WMBadge.Silver -> tierSilver
    WMBadge.Gold -> tierGold
    WMBadge.Platinum -> tierPlatinum
    WMBadge.Diamond -> tierDiamond
    WMBadge.None -> null
}

/**
 * Penpot `Wagemix / Tier Badge`: a 48px medal in the tier colour with an award glyph, the
 * tier name ("Gold tier") and a one-line explanation ("$52K – $60K · Range midpoint above the
 * median"). [tierName] and [explanation] come from the caller's strings.
 */
@Composable
fun WMTierBadge(
    badge: WMBadge,
    tierName: String,
    explanation: String,
    modifier: Modifier = Modifier
) {
    val colors = ColorMode.current.toPalette().fs
    val tier = WMWebTheme.colors.tierColor(badge)
    Row(modifier = Modifier.gap(WMInlineGapVar.value()).then(modifier), verticalAlignment = Alignment.CenterVertically) {
        Box(
            modifier = Modifier
                .size(WMTierMedalVar.value())
                .borderRadius(WMPillCornerVar.value())
                .backgroundColor(tier ?: colors.surfaceContainer)
                .color(if (tier != null) Colors.White else colors.onSurfaceVariant)
                .flexShrink(0),
            contentAlignment = Alignment.Center
        ) {
            WMIcon(if (tier != null) WMIconGlyph.Award else WMIconGlyph.Info, accessibilityString = null)
        }
        Column(modifier = Modifier.gap(WMTightGapVar.value())) {
            SpanText(tierName, WMCardTitleTextStyle.toModifier())
            SpanText(explanation, WMBodySmallTextStyle.toModifier().color(colors.onSurfaceVariant))
        }
    }
}
